import React, { useEffect } from 'react';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { connect } from 'react-redux';
import { showModal, modalBack, hideModal } from 'legacy/actions/modalActions';

interface SubmitButtonProps {
  buttonText: string;
  loading?: boolean;
  errorContent?: string;
  errorActionText?: string;
  errorOpen?: boolean;
  disabled?: boolean;
  type?: 'primary' | 'secondary';
  onSuccess?: () => void;
  className?: string;
  // Redux action creators
  showModal: typeof showModal;
  modalBack: typeof modalBack;
  hideModal: typeof hideModal;
}

const SubmitButton = ({
  buttonText,
  loading,
  errorContent,
  errorActionText,
  errorOpen,
  disabled,
  type,
  onSuccess,
  showModal,
  modalBack,
  hideModal,
  className
}: SubmitButtonProps) => {
  useEffect(() => {
    if (!loading && errorOpen && errorContent) {
      showModal('ALERT', {
        message: errorContent,
        actionText: errorActionText || 'Go back',
        onSuccess: onSuccess || modalBack,
        onBack: hideModal,
        back_img: 'xBlock'
      });
    }
  }, [errorOpen, errorContent, loading]);

  return (
    <Button
      loading={loading}
      disabled={disabled}
      type={!type || type === 'primary' ? ButtonType.Primary : type === 'secondary' ? ButtonType.Secondary : undefined}
      isSubmit
      className={className || 'submit'}
    >
      {buttonText}
    </Button>
  );
};

export default connect(null, { showModal, modalBack, hideModal })(SubmitButton);
